import { useEffect } from "react";
import { motion } from "framer-motion";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";

export const SmoothScroll = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, [pathname]);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const EASE = [0.2, 0.8, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, delay, ease: EASE }} className={className} {...rest}>
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", delay = 0, as: Tag = "h1", testid }) => (
  <Tag className={className} data-testid={testid}>
    {lines.map((l, i) => (
      <span key={`${l}-${i}`} className="block overflow-hidden pb-[0.08em]">
        <motion.span className="block" initial={{ y: "110%" }} animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delay + i * 0.12, ease: [0.7, 0, 0.2, 1] }}>{l}</motion.span>
      </span>
    ))}
  </Tag>
);

export const SectionHead = ({ title, lead, kicker, action, testid }) => (
  <Reveal className="mb-12 flex flex-col gap-6 md:mb-16 md:flex-row md:items-end md:justify-between" data-testid={testid}>
    <div className="max-w-2xl">
      {kicker && <div className="kicker mb-4">{kicker}</div>}
      <h2 className="font-display text-4xl font-bold leading-[0.95] text-white sm:text-5xl lg:text-6xl">{title}</h2>
      {lead && <p className="mt-5 max-w-xl text-sm text-white/65 md:text-base">{lead}</p>}
    </div>
    {action}
  </Reveal>
);

export const Marquee = ({ items }) => (
  <div className="marquee overflow-hidden border-y border-white/10 py-6" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {items.map((it, i) => (
            <span key={`${k}-${i}`} className="flex items-center whitespace-nowrap">
              <span className={`px-8 text-4xl md:text-6xl ${i % 2 ? "font-serif-i text-white/55" : "font-display font-bold text-white"}`}>{it}</span>
              <svg width="22" height="14" viewBox="0 0 22 14" className="shrink-0"><path d="M1 13 L8 2 L12 8 L15 4 L21 13" fill="none" stroke="#5d9a35" strokeWidth="2" /></svg>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
